import { RECEIVE_HEADER_FOOTER, SHOW_POPOVER } from './header-footer-actions';

/**
 * Store universal page defaults here
 * @type {Object}
 */
const DEFAULT_HEADER_FOOTER = {
    header: {
        nav: [],
    },
    footer: {
        barLinks: [],
        groups: [],
        social: { name: '', items: [] },
        countries: [],
    },
    disclaimer: {
        sections: []
    },
    popover: null,
    overlayShade: false
};

const HeaderFooterReducer = (state = DEFAULT_HEADER_FOOTER, action) => {
    Object.freeze(state);
    switch (action.type) {
        case RECEIVE_HEADER_FOOTER:
            return { ...state, ...action.headerFooter };
        case SHOW_POPOVER:
            return { ...state, popover: action.show, overlayShade: action.overlayShade };
        default:
            return state;
    }
};

export default HeaderFooterReducer;
